export default __webpack_public_path__ + "static/media/experience.93b43663.png";